var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFinancials(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.3V19.5M7.6 15.9H10.6C11.2365 15.9 11.847 16.1529 12.2971 16.6029C12.7471 17.053 13 17.6635 13 18.3H1V13.5H5.2C5.83652 13.5 6.44697 13.7529 6.89706 14.2029C7.34714 14.653 7.6 15.2635 7.6 15.9ZM7.6 15.9H5.2M6.2 11.1V5.5C6.2 5.07566 6.36857 4.66869 6.66863 4.36863C6.96869 4.06857 7.37565 3.9 7.8 3.9H17.4C17.8243 3.9 18.2313 4.06857 18.5314 4.36863C18.8314 4.66869 19 5.07566 19 5.5V11.1C19 11.5243 18.8314 11.9313 18.5314 12.2314C18.2313 12.5314 17.8243 12.7 17.4 12.7H9.2M6.2 7.1H19M12.6 7.1V8.7M15 3.9H10.2L10.4888 2.1688C10.5199 1.98159 10.6166 1.81155 10.7615 1.68903C10.9065 1.56652 11.0902 1.49952 11.28 1.5H13.92C14.1094 1.50009 14.2926 1.56735 14.437 1.68981C14.5814 1.81227 14.6777 1.982 14.7088 2.1688L15 3.9Z",
    stroke: "#6E7173",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFinancials);
export default __webpack_public_path__ + "static/media/upload_financials.a3d3405ce31ac1e4d272fb92c694250c.svg";
export { ForwardRef as ReactComponent };